<template>
	<div class="content-box">
		<div class="element-box pt-5">

			<div class="element-content px-5 pb-5">
				<symForm :options="opt" :data="formData" v-on:sended="getUserForm" :form="userForm" :formProcess="formProcess" v-if="userForm" />
			</div>
		</div>
	</div>
</template>

<script>

    import symForm from '@/components/form/symForm.vue'

    export default {
        name: 'bankAccount',
        components: { symForm },
        data () {
            return {
                session: session,
                userLoader: true,
                t: this.$root.t,
                users: null,
                userId: this.$route.query.userId,
                regions: [],
                userGroup: [],
                breadcrumb: [],
                userOpened: false,
                userForm: null,
                formProcess: 0,
                opt: {
                    region: {data: [], label: 'nationallity'},
                    userGroup: {data: [], label: 'name'}
                },
                formData: []
            }
        },
        mounted () {
            this.getUserForm();
        },
        notifications: {
            showFormError: { // You can have any name you want instead of 'showLoginError'
                title: 'Login Failed',
                message: 'Failed to authenticate',
                type: 'error' // You also can use 'VueNotifications.types.error' instead of 'error'
            }
        },
        methods: {
            async getUserForm (data) {

                if(this.session.uid > 0) {
                    this.userForm = null;
                    this.formProcess = 0;

                    var id = (this.$route.params.id) ? 'edit/'+this.$route.params.id : 'create';

                    this.$bus.$emit('globalLoader', 1);

                    if(data) {
                        //this.userForm = null;
                        this.$http.post(api+'api/v1/user/accounting/bankAccounts/process/'+id+'?access_token='+this.$root.oauth.accessToken,
                            data )
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formProcess = 200;

                                swal('', this.t.processing.success, "success");

                                if (id == 'create') {
                                    this.$router.push({name: 'bank_account_edit', params: {id: response.body.id}});
                                }

                                this.$bus.$emit('globalLoader', 0);
                            }, response => {
                                this.userForm = response.body.result;
                                this.formProcess = 400;
                                this.$bus.$emit('globalLoader', 0);
                                swal(this.t.processing.error, this.t.processing.check, "error")
                            })

                    } else {
                        this.$http.get(api+'api/v1/user/accounting/bankAccounts/process/'+id+'?access_token='+this.$root.oauth.accessToken)
                            .then(response => {

                                this.userForm = response.body.result;
                                this.formData = response.body.form_data;
                                this.$bus.$emit('globalLoader', 0);

                            }, response => {
                                this.$bus.$emit('globalLoader', 0);
                            })
                    }
                }
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user/account/form/bankAccount.vue